<template>
  <div class=" is-fullwidth">
    <table class="table is-hoverable is-fullwidth" id="orderstable">
    	<thead>
    		<th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Order Date</th>
   	 		<th>Ref</th>
          <th v-if="showProductionLocation">Production</th>
          <th v-if="$route.meta.screen === 'new'">Artwork</th>
          <th v-if="$route.meta.screen === 'new' ">Process</th>
           <th v-if="$route.meta.screen === 'artwork' || $route.meta.screen === 'print' || $route.meta.screen === 'application'">Process</th>
          <th v-if="$route.meta.screen === 'cutting'">Make Up</th>
          <th v-if="$route.meta.screen === 'cutting' " >Process</th>
          <th v-if="$route.meta.screen === 'makeup'">Process</th>
          
    	</thead>
    	<tbody>
		    <tr v-for="order in orders" v-bind:key="order.orderID">
          <td ><span @click="showModal=true;selectedOrderID=order.orderID">{{order.ponumber}}</span></td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.orderDate}}</td>
          <td>{{order.orderReference}}</td>
          
            
             

              <td v-if="showProductionLocation">  
              <div class="buttons has-addons ">
              <button class="button is-small" :class="[order.productionlocation=== 'Strabane' ? 'is-success' : '']" @click="order.productionlocation='Strabane'">Strabane</button>
              <button class="button is-small " :class="[order.productionlocation=== 'Giurgiu' ? 'is-success' : '']" @click="order.productionlocation='Giurgiu'">Giurgiu</button>
              
            </div>
            </td>
              <td v-if="$route.meta.screen === 'new' ">
          <div class="buttons has-addons " >
              <button class="button is-small" :class="[order.artwork === 'New' ? 'is-success' : '']" @click="order.artwork='New'">New</button>
              <button class="button is-small " :class="[order.artwork === 'Repeat' ? 'is-danger' : '']" @click="order.artwork='Repeat'">Repeat</button>
              
            </div>
              </td>
               <td v-if="$route.meta.screen === 'new'">
                <button class="button is-small is-info" v-if="order.productionlocation !== '' && order.artwork !== ''" >Process</button>

              </td>
              <td v-if="$route.meta.screen === 'artwork' || $route.meta.screen === 'print' || $route.meta.screen === 'application' ">
                <button class="button is-small is-info"  >Process</button>

              </td>
              <td v-if="$route.meta.screen === 'cutting'">
                 <div class="buttons has-addons ">
                  <button class="button is-small" :class="[order.makeuplocation=== 'Dublin' ? 'is-success' : '']" @click="order.makeuplocation='Dublin'">Dublin</button>
                  <button class="button is-small" :class="[order.makeuplocation=== 'Strabane' ? 'is-success' : '']" @click="order.makeuplocation='Strabane'">Strabane</button>
                  <button class="button is-small" :class="[order.makeuplocation=== 'Derry' ? 'is-success' : '']" @click="order.makeuplocation='Derry'">Derry</button>
                  <button class="button is-small " :class="[order.makeuplocation=== 'Giurgiu' ? 'is-success' : '']" @click="order.makeuplocation='Giurgiu'">Giurgiu</button>
                  
                </div>
              </td>
              <td v-if="$route.meta.screen === 'cutting' " >
                  <button class="button is-small is-info" v-if="order.makeuplocation !== '' ">Process</button>
              </td>
              <td v-if="$route.meta.screen === 'makeup'" >
                  <button class="button is-small is-info"  >Complete</button>
              </td>
			</tr>
    	</tbody>
    </table>
    
    <button @click="exportXLS()">Export</button>
    
    <OrderModal :showModal="showModal" @closeModal="showModal=false" :orderID="selectedOrderID"/>


    
    
    
  </div>
</template>

<script>
import XLSX from 'xlsx';

import OrderModal from '@/components/OrderModal';

//import OrderService from '@/services/OrderService.js';

import StrabanePrintOrders from '@/data/StrabanePrintOrders.js'
import GiurgiuPrintOrders from '@/data/GiurgiuPrintOrders.js'
import NewOrders from '@/data/NewOrders.js'
import ArtworkOrders from '@/data/ArtworkOrders.js'

export default {
  components: {
   	OrderModal
  },
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0
     
    }
  },
   methods: {
  	
   // async getOrderData() {
    //  const accessToken = await this.$auth.getTokenSilently()
      // Use the eventService to call the getEventSingle() method
   //   OrderService.getOrders(accessToken)
    //  .then(
    //    (orders => {
    //      this.$set(this, "orders", orders);
   //     }).bind(this)
    //  );
    //},
    
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet JS"});
		 XLSX.writeFile(wb, 'book.xlsx')

	 },
    updateOrders() {
      if(this.$route.meta.screen === "new")
        {
          this.orders = NewOrders
        }
        else if(this.$route.meta.screen === "artwork")
        {
          this.orders = ArtworkOrders
        }
      else if(this.$route.meta.productionlocation === "strabane" || this.$route.params.productionlocation === "strabane")
        {
          this.orders = StrabanePrintOrders
        }
        else{
          this.orders =  GiurgiuPrintOrders
        }
    }
  },
  computed : {
      showProductionLocation: function() {
        if(this.$route.meta.screen === 'new')
        {
          return true;
        }

        return false;
      } ,
      showProcessArtwork: function() {
        if(this.$route.meta.screen === 'artwork')
        {
          return true;
        }

        return false;
      } 

  },

  // Fetches posts when the component is created.
  created() {
    //this.getOrderData();
    
   
  },
 
  mounted() {
    this.updateOrders()
      
  },
  watch: {
    '$route'() {
      this.updateOrders()
    }
  }
}

// used to be on button  v-if="this.user["https://app.test202.co.uk/roles"].includes('sales')"

</script>

<style>
	td span {cursor:pointer;text-decoration:underline #ccc}
  table.is-hoverable tbody tr:hover {background-color:#ededed !important}
</style>
